<template>

    <div>
        <img v-show="bookmark" src="../assets/images/icon_bookmark_yes.png" alt="[+]" title="Remove this publication from your bookmarks" @click="removeBookmark()"/>
        <img v-show="!bookmark" src="../assets/images/icon_bookmark_no.png" alt="[-]" title="Add this publication to your bookmarks" @click="addBookmark()"/>
    </div>

</template>

<script>

    import { mapActions } from 'vuex'

    export default {
      name: 'Bookmark',
      props: {
        bookmark_init: {
            type: Boolean,
            default: false
        },
        variant: {
            type: String,
            required: true
        },
        collection_name: {
            type: String,
            required: true
        },
        collection_title: {
            type: String,
            required: true
        },
        doc_id: {
            type: String,
            required: true
        },
        item : {
            type: Object,
            required: true
        },
        position: {
            type: Number,
            default: null
        }
      },
      data() {
        return {
            bookmark: this.bookmark_init,
        };
      },
      methods: {
        ...mapActions(['addBookmarkedPublication', 'removeBookmarkedPublication']),
        addBookmark(){
           var data = {}
           data.variant = this.variant
           data.collection = this.collection_title
           data.document = this.doc_id
           data.item = this.item
           this.addBookmarkedPublication(data)
           this.bookmark = true
           this.$matomo?.trackEvent("Bookmark added", this.collection_name+";"+this.doc_id+";"+this.position);
           this.$matomo?.trackEvent("Relevance by bookmark", this.variant+";"+this.collection_name+";"+this.position+";"+this.doc_id);
       },
       removeBookmark(){
           var data = {}
           data.variant = this.variant
           data.collection = this.collection_title
           data.document = this.doc_id
           this.removeBookmarkedPublication(data)
           this.bookmark = false
           this.$matomo?.trackEvent("Bookmark removed", this.collection_name+";"+this.doc_id+";"+this.position);
       },
      }
    }

</script>

<style scoped lang="scss">

    img {
        width: 15px;
        cursor: pointer;
    }

</style>